import { Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ProductListService } from 'src/app/service/product-list.service';
import { ProductServiceService } from 'src/app/service/product-service.service';
import Swal from 'sweetalert2';

interface Category {
  name: string;
}

@Component({
	selector: 'app-upcoming-products',
	templateUrl: './upcoming-products.component.html',
	styleUrls: ['./upcoming-products.component.scss']
})
export class UpcomingProductsComponent implements OnInit {
	isNew: boolean = false;
	constructor(private allProducts: ProductServiceService) { }
	isSidebarVisible = false;
	toggleSidebar() {
		this.isSidebarVisible = !this.isSidebarVisible;
	}

	checkBoxStatusClicked(id: any, val: boolean) {
		let status = this.allProducts.not_new_status;
		if (!val) {
			status = this.allProducts.new_status;
		}
		this.allProducts.editStatusByAdmin(id, status).subscribe(res => {
			var status = res.status;
			if (status == 'success') {
				Swal.fire({
					title: 'Successfully updated the status!',
				}).then((result) => {
					//location.reload();
				})
			} else {
				Swal.fire({
					title: 'Error with updating the status!',
				}).then((result) => {
				//	location.reload();
				})
			}
		})
		console.log("id " + id + " Val " + val + " !val " + !val);
	}


	checkBoxInHomeBannerClicked(id: any, val: boolean) {
		this.allProducts.editHomeBannerByAdmin(id, val).subscribe(res => {
			var status = res.status;
			if (status == 'success') {
				Swal.fire({
					title: 'Successfully updated!',
				}).then((result) => {
					//location.reload();
				})
			} else {
				Swal.fire({
					title: 'Error with updating!',
				}).then((result) => {
					//location.reload();
				})
			}
		})
		console.log("id " + id + " Val " + val + " !val " + !val);
	}
	categories: Category[] = [];
	singleProductsItem = [];
	paginatedProducts = [];
	currentPage = 1;
	itemsPerPage = 12;
	totalPages = 1;
	ngOnInit(): void {
		this.categories = [
			{ 'name': this.allProducts.all_status },
			{ 'name': this.allProducts.mirrorless_cameras },
			{ 'name': this.allProducts.DSLR },
			{ 'name': this.allProducts.new_status }

		]
		this.allProducts.getAllDetails().subscribe(res => {
			this.singleProductsItem = res;
			this.totalPages = Math.ceil(this.singleProductsItem.length / this.itemsPerPage);
			this.updatePagination();

		});

	}
	selectedCategory: string = this.allProducts.all_status;
	filterProductsByCategory(category: any) {

		this.singleProductsItem = [];
		this.selectedCategory = category;
		console.log("category " + category);
		if (category == this.allProducts.all_status) {
			this.allProducts.getAllDetails().subscribe(res => {
				this.singleProductsItem = res;
				this.updatePagination();

			});
		} else if (category == this.allProducts.mirrorless_cameras) {
			this.allProducts.getProductsByType(this.allProducts.mirrorless_cameras).subscribe(res => {
				this.singleProductsItem = res;
				this.updatePagination();
			})
		} else if (category == this.allProducts.DSLR) {
			this.allProducts.getProductsByType(this.allProducts.DSLR).subscribe(res => {
				this.singleProductsItem = res;
				this.updatePagination();
			})
		} else if (category == this.allProducts.new_status) {
			this.allProducts.getNewProducts().subscribe(res => {
				this.singleProductsItem = res;
				this.updatePagination();

			})
		}


	}

	sectionTitle = [
		{
			title: "All Products",
			paragraph: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida."
		}
	]


	updatePagination() {
		this.totalPages = Math.ceil(this.singleProductsItem.length / this.itemsPerPage);
		const startIndex = (this.currentPage - 1) * this.itemsPerPage;
		this.paginatedProducts = this.singleProductsItem.slice(startIndex, startIndex + this.itemsPerPage);
	}

	nextPage() {
		if (this.currentPage < this.totalPages) {
			this.currentPage++;
			this.updatePagination();
		}
	}

	previousPage() {
		if (this.currentPage > 1) {
			this.currentPage--;
			this.updatePagination();
		}
	}


}